import { z } from 'zod';

export const DEFAULT_PAGE = 1;
export const DEFAULT_LIMIT = 20;
export const MAX_LIMIT = 100;

export const uuidSchema = z.uuid({ message: '올바른 식별자 형식이 아닙니다.' });

/** UUID를 DB 식별자·참조로 비교하는 계약에서만 사용한다. 불투명 문자열 키에는 적용하지 않는다. */
/** 형식뿐 아니라 윤년·월별 일수도 검사하는 YYYY-MM-DD 달력 날짜. */
export const calendarDateSchema = z.iso.date().refine((value) => {
  const date = new Date(`${value}T00:00:00.000Z`);
  return (
    value.slice(0, 4) !== '0000' &&
    Number.isFinite(date.getTime()) &&
    date.toISOString().slice(0, 10) === value
  );
}, '올바른 달력 날짜를 입력해 주세요.');

export const normalizedUuidSchema = uuidSchema.toLowerCase();

/** S3 키 같은 문자열 형식 검사에서 uuid 세그먼트를 고정하는 정규식 조각. (catalog·editor 키 형식이 공유) */
export const UUID_PATTERN =
  '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';

export const paginationSchema = z.object({
  page: z.coerce.number().int().min(1).default(DEFAULT_PAGE),
  limit: z.coerce.number().int().min(1).max(MAX_LIMIT).default(DEFAULT_LIMIT),
});

export type PaginationInput = z.infer<typeof paginationSchema>;

export const paginationMetaSchema = z.object({
  total: z.number().int().nonnegative(),
  page: z.number().int().min(1),
  limit: z.number().int().min(1),
  totalPages: z.number().int().nonnegative(),
});

export type PaginationMeta = z.infer<typeof paginationMetaSchema>;

/** 페이지네이션 응답 스키마를 만든다. */
export const paginatedSchema = <TItem extends z.ZodType>(item: TItem) =>
  z.object({
    items: z.array(item),
    meta: paginationMetaSchema,
  });

export const idParamSchema = z.object({ id: uuidSchema });
